import { generatePath, useHistory } from 'react-router-dom';

export const useGenerateFullPath = () => {
  const history = useHistory();
  return ({ path, params = {} }) =>
    history.createHref({
      pathname: generatePath(path, params),
    });
};
